// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { IdlOptions, IdlOptionsT, verifyIdlOptions } from "./idl-options";

/**
 * Re-verify a stored mapping: blob integrity, input binding, and that the
 * stored translation equals a rebuild.
 */
export class CheckRequest implements flatbuffers.IUnpackableObject<CheckRequestT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): CheckRequest {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsCheckRequest(bb: flatbuffers.ByteBuffer, obj?: CheckRequest): CheckRequest {
    return (obj || new CheckRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsCheckRequest(
    bb: flatbuffers.ByteBuffer,
    obj?: CheckRequest,
  ): CheckRequest {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new CheckRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  cdoBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  cdoBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  cdoBinaryArray(): Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return new Uint8Array(
      this.bb!.bytes().buffer,
      this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
      this.bb!.__vector_len(this.bb_pos + offset),
    );
  }

  options(obj?: IdlOptions): IdlOptions | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new IdlOptions()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startCheckRequest(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addCdoBinary(builder: flatbuffers.Builder, cdoBinaryOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, cdoBinaryOffset, 0);
  }

  static createCdoBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startCdoBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addOptions(builder: flatbuffers.Builder, optionsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, optionsOffset, 0);
  }

  static endCheckRequest(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // cdo_binary
    return offset;
  }

  unpack(): CheckRequestT {
    return new CheckRequestT(
      this.bb!.createScalarList<number>(this.cdoBinary.bind(this), this.cdoBinaryLength()),
      this.options() !== null ? this.options()!.unpack() : null,
    );
  }

  unpackTo(_o: CheckRequestT): void {
    _o.cdoBinary = this.bb!.createScalarList<number>(
      this.cdoBinary.bind(this),
      this.cdoBinaryLength(),
    );
    _o.options = this.options() !== null ? this.options()!.unpack() : null;
  }

  unpackFields(...fields: string[]): CheckRequestT {
    const t = new CheckRequestT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("cdo_binary")) {
      t.cdoBinary = this.bb!.createScalarList<number>(
        this.cdoBinary.bind(this),
        this.cdoBinaryLength(),
      );
    }
    if (fieldSet.has("options")) {
      t.options = this.options() !== null ? this.options()!.unpack() : null;
    }
    return t;
  }
}

export class CheckRequestT implements flatbuffers.IGeneratedObject {
  constructor(
    public cdoBinary: number[] = [],
    public options: IdlOptionsT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.cdoBinary === null || this.cdoBinary === undefined) {
      throw new Error('Required field "cdo_binary" is not set');
    }
    const cdoBinary = CheckRequest.createCdoBinaryVector(builder, this.cdoBinary);
    const options = this.options !== null ? this.options!.pack(builder) : 0;

    CheckRequest.startCheckRequest(builder);
    CheckRequest.addCdoBinary(builder, cdoBinary);
    CheckRequest.addOptions(builder, options);

    return CheckRequest.endCheckRequest(builder);
  }

  clone(): CheckRequestT {
    const obj = new CheckRequestT();
    obj.cdoBinary = [...this.cdoBinary];
    obj.options = this.options !== null ? this.options!.clone() : null;
    return obj;
  }

  equals(other: CheckRequestT): boolean {
    if (this.cdoBinary.length !== other.cdoBinary.length) return false;
    for (let i = 0; i < this.cdoBinary.length; i++) {
      if (this.cdoBinary[i] !== other.cdoBinary[i]) return false;
    }
    if (this.options !== null && other.options !== null) {
      if (!this.options!.equals(other.options!)) return false;
    } else if (this.options !== other.options) return false;
    return true;
  }
}

export function verifyCheckRequest(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "cdo_binary");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyIdlOptions(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
